const VConsole = require('vconsole')
const vConsole =
  process.env.NODE_ENV === 'development' || process.env.customEnv === 'imf1'
    ? new VConsole()
    : ''

if (vConsole) {
  const myPlugin = require('./colorPlugin')

  vConsole.addPlugin(myPlugin)
}

// module.exports = myPlugin

export default vConsole
